import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PcbMappingService} from '../../shared/services/pcb-mapping.service';
import {UniversityCourseCurriculumService} from '../../shared/services/university-course-curriculum.service';

@Component({
    selector: 'app-pcb-mapping',
    templateUrl: './pcb-mapping.component.html',
    styleUrls: ['./pcb-mapping.component.scss']
})
export class PcbMappingComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    updatePasswordForm: FormGroup;
    inputTypePassword = 'password';
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    pcbmapping = [];

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private pcbMappingService: PcbMappingService,
                private universityCourseCurriculumService : UniversityCourseCurriculumService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-pcb-mapping').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'program_id': [''],
            'course_id': [''],
            'branch_id': [''],
        });
        this.get();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.pcbmapping = [];
        this.pcbMappingService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.pcbmapping = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.pcbmapping = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'program_id': (this.searchForm.value && this.searchForm.value.program_id) ? this.searchForm.value.program_id : '',
            'course_id': (this.searchForm.value && this.searchForm.value.course_id) ? this.searchForm.value.course_id : '',
            'branch_id': (this.searchForm.value && this.searchForm.value.branch_id) ? this.searchForm.value.branch_id : '',
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            program_id: (this.searchForm && this.searchForm.value && this.searchForm.value.program_id) ? this.searchForm.value.program_id : '',
            course_id: (this.searchForm && this.searchForm.value && this.searchForm.value.course_id) ? this.searchForm.value.course_id : '',
            branch_id: (this.searchForm && this.searchForm.value && this.searchForm.value.branch_id) ? this.searchForm.value.branch_id : '',
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.pcbMappingService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    courseCurriculum(data: any) {
        this.router.navigateByUrl('course-curriculum/' + data.id);
    }
}
